import * as React from 'react'

import { ISlice, ITextProcessor } from '../processor/constants'
import { sliceArraysEqual } from '../processor/helpers'
import { getSlicesAt } from '../processor/selectors/textProcessorSelectors'

export type SliceFC<T = SafeUnknownObject> = React.FunctionComponent<T & { slice: ISlice }>

// This function used instead of a component to get strings as children in leaf slices
const renderFragment = (slices: ISlice[], text: string, Slice: SliceFC, key?: number) => {
  if (slices.length === 0) {
    return text
  }
  return (
    <Slice key={key} slice={slices[0]}>
      {renderFragment(slices.slice(1), text, Slice)}
    </Slice>
  )
}

export interface SlicesOrderComparator {
  (a: ISlice, b: ISlice): number
}

interface EditorContentProps {
  processor: ITextProcessor
  sliceComponent: SliceFC
  sortSlices?: SlicesOrderComparator
}

const EditorContent = ({ processor, sliceComponent, sortSlices }: EditorContentProps) => {
  const state = processor.getState()
  let currentSlices: ISlice[] = getSlicesAt(state, 0)
  let text = ''
  const fragments: Array<string | React.ReactElement> = []

  const flush = (key: number) => {
    const slices = sortSlices ? currentSlices.sort(sortSlices) : currentSlices
    fragments.push(renderFragment(slices, text, sliceComponent, key))
    text = ''
  }

  for (let i = 0; i < state.text.length; i++) {
    const nextSlices = getSlicesAt(state, i)
    if (!sliceArraysEqual(currentSlices, nextSlices)) {
      flush(i)
      currentSlices = nextSlices
    }
    text += state.text[i]
  }

  if (text.length > 0) {
    flush(-1)
  }

  return <>{fragments}</>
}

export default EditorContent
